<template>
  <div class="p-6">
    <CancellationPolicyFull v-if="hasFullCancellationPolicy" @close="$emit('close')" />
    <div v-else>
      <h3 class="text-[18px] font-bold text-grey-light-900">Cancellation Policy</h3>

      <p class="text-[14px] text-grey-light-600 mt-1">
        If you choose to cancel this payment plan the following fees will apply.
      </p>

      <hr class="my-4" />

      <RefundSummary
        :refund-before-deductions="refundBeforeDeductions"
        :cancellation-fee="cancellationFee"
        :refund-after-deductions="refundAfterDeductions"
      />

      <div class="mt-6 space-y-4">
        <div>
          <p class="text-[14px] font-semibold text-grey-light-700 mb-2">Reason for cancelling</p>
          <Select :model-value="selectedReason" @update:model-value="$emit('update:selectedReason', $event)">
            <SelectTrigger :class="isDesktop ? 'max-w-[400px]' : 'max-w-[350px]'">
              <SelectValue placeholder="Please select your reason" />
            </SelectTrigger>
            <SelectContent :class="isDesktop ? 'max-w-[400px]' : 'max-w-[350px]'">
              <SelectItem v-for="reason in cancellationReasons" :key="reason" :value="reason">
                {{ reason }}
              </SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div class="flex items-center gap-2">
          <Checkbox
            id="agree-policy"
            :model-value="agreedToPolicy"
            @update:model-value="$emit('update:agreedToPolicy', !!$event)"
          />
          <label for="agree-policy" class="text-[14px] text-grey-light-700 cursor-pointer">
            I agree with the <span class="underline font-medium">Cancellation Policy</span>
          </label>
        </div>
      </div>

      <hr class="my-4" />

      <div class="flex gap-3">
        <Button variant="outline" class="flex-1" @click="$emit('close')">Cancel</Button>
        <Button
          v-if="cancellationFee > 0"
          variant="outline"
          class="flex-1"
          :disabled="!selectedReason || !agreedToPolicy"
          @click="$emit('dispute')"
        >
          Dispute
        </Button>
        <Button
          class="flex-1 bg-teal-600 hover:bg-teal-700"
          :disabled="!selectedReason || !agreedToPolicy"
          @click="$emit('continue')"
        >
          Continue
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CancellationPolicyFull from '@/components/shopper/lay-by/cancellation-request/CancellationPolicyFull.vue';
import RefundSummary from '@/components/shopper/lay-by/cancellation-request/RefundSummary.vue';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBreakpoint } from '@/utils/useBreakPoint';

const { isDesktop } = useBreakpoint();

defineProps<{
  refundBeforeDeductions: number;
  cancellationFee: number;
  refundAfterDeductions: number;
  selectedReason: string;
  agreedToPolicy: boolean;
  cancellationReasons: string[];
  hasFullCancellationPolicy: boolean;
}>();

defineEmits<{
  'update:selectedReason': [value: string];
  'update:agreedToPolicy': [value: boolean];
  continue: [];
  dispute: [];
  close: [];
  accept: [];
}>();
</script>
